import React from 'react';

const W8PrivacyNoticeCard = () => {
  return (
    <div className="d-flex gap-3 mb-4 notice_card">
      <div>
        <i className="fa-solid fa-shield-halved"></i>
      </div>
      <div className="w-full">
        <h4>Privacy Notice</h4>
        <p>
          The information you provide on this form is securely encrypted and collected under the Internal Revenue Code to determine your tax status.
        </p>
      </div>
    </div>
  );
};

export default W8PrivacyNoticeCard;
